import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { URL_SERVICIOS } from "../../../environments/environment";
import { PagoCliente } from "../../models/pago-cliente";
import { Rest } from "../../models/rest";
import { AuthService } from "../auth/auth.service";
import { MovimientosService } from "../movimientos/movimientos.service";

@Injectable({
  providedIn: "root",
})
export class PagosClientesService implements Rest<PagoCliente> {
  public _url: string = `${URL_SERVICIOS}pagos_clientes`;

  constructor(
    private http: HttpClient,
    private _movimientosService: MovimientosService,
    private _authService: AuthService
  ) {}
  get(condiciones?: any) {
    return this.http
      .get(this._url, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  getById(id: string) {
    return this.http.get(`${this._url}/byid/${id}`).pipe(
      map((res: any) => {
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  check_pagos_credito(expediente_id: string) {
    return this.http
      .get(`${this._url}/check_saldos_credito/${expediente_id}`)
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }
  filtrado(condiciones?: any) {
    return this.http
      .get(`${this._url}/filtrado`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  filtrado_creditos(condiciones?: any) {
    return this.http
      .get(`${this._url}/filtrado_creditos`, {
        params: { condiciones: JSON.stringify([condiciones]) },
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError((err: any) => {
          return throwError(err);
        })
      );
  }

  insert(obj: PagoCliente) {
    return this.http.post(this._url, obj).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Pagos Clientes",
          motivo: "Adición de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  update(id: string, obj: PagoCliente) {
    return this.http.put(`${this._url}/${id}`, obj).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Pagos Clientes",
          motivo: "Edición de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
  delete(id: string) {
    return this.http.delete(`${this._url}/${id}`).pipe(
      map((res: any) => {
        const obj_movimiento_t = {
          tabla: "Pagos Clientes",
          motivo: "Borrado de registro ",
          agentes_id: this._authService.user.id,
        };
        this._movimientosService
          .insert(obj_movimiento_t)
          .subscribe((res: any) => {});
        return res;
      }),
      catchError((err: any) => {
        return throwError(err);
      })
    );
  }
}
